import type { Component, Entity2D } from '../../odie';
import { getGameScene } from '../getGameScene';

import { CountBlockOptionDef, SkullBlockProps } from '../defs/block';
import { SkullBlockView } from '../views/blocks/SkullBlockView';

// types
//-----------------------------------------------------------------------------
export type SkullBlockComponentOptions = {
  props: SkullBlockProps;
  option?: number;
};

/*
    skull block component
*/
export class SkullBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockSkull';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: SkullBlockView;
  // state
  private _idle!: boolean;

  // properties
  //-------------------------------------------------------------------------
  private props!: SkullBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
    this._idle = false;
  }

  // idle
  public get idle(): boolean {
    return this._idle;
  }

  public set idle(value: boolean) {
    this._idle = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: SkullBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new SkullBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set initial idle state. This block is a bit different from the others as it starts idle regardless
    // of option defined, but that should change if the game is being loaded from a save state.
    this._idle = getGameScene()?.usingSaveState ? this.count !== 0 : true;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
